import { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiClient } from "@/context/AuthContext";
import { useCrumbs } from "@/context/CrumbContext";
import NewAssessmentLauncher from "@/components/NewAssessmentLauncher";
import { ArrowUpRight, Camera, Loader2, Plus, Search } from "lucide-react";

const FILTERS = [["all", "Tümü"], ["bad", "Uygunsuz var"], ["pending", "Doğrulama bekleyen"], ["done", "Tamamlanan"]];

export default function AssessmentsList() {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  const [searchParams] = useSearchParams();
  const [q, setQ] = useState(searchParams.get("q") || "");
  const [filter, setFilter] = useState("all");
  const [showNew, setShowNew] = useState(false);
  useCrumbs([{ label: "Değerlendirmeler", to: "/assessments" }]);

  useEffect(() => { apiClient.get("/assessments").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);

  const shown = useMemo(() => (rows || []).filter((a) => {
    const text = `${a.title} ${a.building_name} ${a.project_name} ${a.location}`.toLocaleLowerCase("tr");
    if (q && !text.includes(q.toLocaleLowerCase("tr"))) return false;
    if (filter === "bad") return a.counts.bad > 0;
    if (filter === "pending") return a.counts.pending > 0;
    if (filter === "done") return a.counts.pending === 0 && a.counts.total > 0;
    return true;
  }), [rows, q, filter]);

  return (
    <div className="content-wrap" data-testid="assessments-page">
      <div className="page-heading">
        <div><div className="eyebrow">TÜM ÇALIŞMALAR</div><h1>Değerlendirmeler</h1><p>{rows ? `${rows.length} değerlendirme` : "Yükleniyor…"}</p></div>
        <div className="heading-actions"><button className="primary-btn" onClick={() => setShowNew(true)} data-testid="new-assessment-button"><Plus size={16}/> Yeni değerlendirme</button></div>
      </div>
      <div className="list-toolbar">
        <label className="search-box"><Search size={14}/><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Bina, proje veya şehir ara" data-testid="assessments-search"/></label>
        <div className="filter-row">
          {FILTERS.map(([k, l]) => <button key={k} className={filter === k ? "chip active" : "chip"} onClick={() => setFilter(k)} data-testid={`assessments-filter-${k}`}>{l}</button>)}
        </div>
      </div>
      {!rows ? <div className="page-loading"><Loader2 className="spin" size={18}/></div> : (
        <div className="data-table" data-testid="assessments-table">
          <div className="data-head"><span>Değerlendirme</span><span>Konum</span><span>Durum</span><span>Rapor</span><span/></div>
          {shown.map((a) => (
            <div key={a.id} className="data-row" onClick={() => navigate(`/assessments/${a.id}`)} data-testid={`assessment-row-${a.id}`}>
              <div><strong>{a.title}</strong><small>{a.building_name} · {a.project_name}</small></div>
              <span>{a.location || "—"}</span>
              <span className="status-pills">
                <i className="pill ok">{a.counts.ok} uygun</i>
                {a.counts.bad > 0 && <i className="pill bad">{a.counts.bad} uygunsuz</i>}
                {a.counts.pending > 0 && <i className="pill warn">{a.counts.pending} bekleyen</i>}
              </span>
              <span className="mono">{a.last_revision || "—"}</span>
              <span className="row-actions">
                <button className="icon-button" title="Saha modu" onClick={(e) => { e.stopPropagation(); navigate(`/saha/${a.id}`); }} data-testid={`assessment-field-${a.id}`}><Camera size={14}/></button>
                <ArrowUpRight size={14}/>
              </span>
            </div>
          ))}
          {!shown.length && <div className="data-empty">Aramanıza uyan değerlendirme yok.</div>}
        </div>
      )}
      {showNew && <NewAssessmentLauncher onClose={() => setShowNew(false)}/>}
    </div>
  );
}
